import { useContext } from 'react';
import { withBaseUrl } from '../../../js/api/url';
import { WebshopContext } from './WebshopContextProvider';

export const useWithSiteUrl = (): (uri: string) => string => withBaseUrl(useContext(WebshopContext).siteUrl);
export const useWithStaticUrl = (): (uri: string) => string => withBaseUrl(useContext(WebshopContext).staticUrl);
export const useWithEditorFileServiceUrl = (): (uri: string) => string => withBaseUrl(`${useContext(WebshopContext).staticUrl}fs/editor-file/`);
export const useWithImageUrl = (): (uri: string) => string => withBaseUrl(`${useContext(WebshopContext).assetsUrl}images/`);
export const useIsInitialRequestMobile = (): boolean => useContext(WebshopContext).isMobile;
